import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { trpc } from "@/lib/trpc";
import {
  ETAPAS_PADRAO, etapasDePauta, parseQuadro, quadroDoCliente, rotuloEtapa, estaNoQuadro,
  type EtapaDef,
} from "@shared/etapas";

// Quadro (etapas) do cliente ativo, em qualquer tela. Out/26: telas fora do
// kanban (calendário, busca, dashboard, métricas) usavam lista fixa com
// "Roteiro"; agora todas leem a config do cliente pela mesma consulta, que o
// react-query guarda em cache.
export function useQuadro(clientIdArg?: number | null) {
  const { session } = useAuth();
  // Mesmo padrão das páginas (Calendário, Métricas, Dashboard): sem cliente
  // ativo ("Todos os clientes"), elas mostram o cliente 1; o quadro acompanha.
  const clientId = clientIdArg ?? session?.activeClientId ?? session?.clientId ?? 1;
  const q = trpc.columns.get.useQuery(
    { clientId: clientId ?? undefined },
    { enabled: !!clientId, staleTime: 5 * 60_000 },
  );
  return useMemo(() => {
    const quadro: EtapaDef[] = quadroDoCliente(parseQuadro(q.data));
    return {
      quadro,
      // Só etapas de pauta (sem "Sugestão de Tema", que é etapa de tema).
      etapasPauta: etapasDePauta(quadro),
      rotulo: (id: string | null | undefined) => rotuloEtapa(id, quadro),
      noQuadro: (id: string | null | undefined) => estaNoQuadro(id, quadro),
      // false enquanto a config do cliente não chegou (evita mostrar o
      // quadro padrão por um instante).
      carregado: !clientId || q.isFetched || q.isError,
    };
  }, [q.data, q.isFetched, q.isError, clientId]);
}

export { ETAPAS_PADRAO };
